import React from "react";
import { FaCalendarTimes } from "react-icons/fa";
import Button from "../../components/Button";

// Tournament creation is disabled while this platform is being retired.
// Any tournament created here would be lost in the migration to the new platform.
const Organize = () => {
  return (
    <div className="flex flex-col max-w-xl w-11/12 bg-white mt-8 p-8 items-center rounded-xl shadow-xl border border-yellow-500">
      <FaCalendarTimes className="text-yellow-500 text-6xl mb-6" />

      <h2 className="text-2xl font-semibold text-center text-gray-900 mb-4">
        Shuffle Polo Is Moving
      </h2>
      <p className="text-center text-gray-700 mb-4">
        New tournaments can no longer be created here. Please create your
        tournament on the new Shuffle Polo platform.
      </p>

      <a href="https://beta.shufflepolo.com">
        <Button color="yellow" className="bg-yellow-500">
          Go to beta.shufflepolo.com
        </Button>
      </a>
    </div>
  );
};
export default Organize;
